import { createApp } from 'vue';
import App from './App.vue';
import Notifications from '@kyvg/vue3-notification';

import './assets/scss/main.scss';

import { OhVueIcon, addIcons } from 'oh-vue-icons';
import { HiPencil } from 'oh-vue-icons/icons/hi/index';
import { RiDeleteBin4Fill, RiCloseLine} from 'oh-vue-icons/icons';

addIcons(HiPencil, RiDeleteBin4Fill, RiCloseLine);

createApp(App).use(Notifications).component('v-icon', OhVueIcon).mount('#app');
